import { createApi } from '@reduxjs/toolkit/query/react';
import { getCampaignEndpoint } from './endpoints/getCampaign';
import { baseQuery } from './baseQuery';
import { getCampaignsEndpoint } from './endpoints/getCampaigns';
import { getCampaignAlertsEndpoint } from './endpoints/getCampaignAlerts';
import { getCampaignHealthStatusEndpoint } from './endpoints/getCampaignHealthStatus';
import { getCampaignQuotaStatsEndpoint } from './endpoints/getCampaignQuotaStats';
import { getCampaignCompletesStatsEndpoint } from './endpoints/getCampaignCompletesStats';
import { getCampaignMatchesStatsEndpoint } from './endpoints/getCampaignMatchesStats';
import { getPutResetCampaignPreflight } from './endpoints/putResetCampaignPreflight';
export var tapiReducerPath = 'tapi';
export var tapi = createApi({
    reducerPath: tapiReducerPath,
    baseQuery: baseQuery,
    // When we start having more endpoints we'll need to consider moving the endpoints
    // to separate folders
    endpoints: function(builder) {
        return {
            getCampaign: getCampaignEndpoint(builder),
            getCampaigns: getCampaignsEndpoint(builder),
            getCampaignAlerts: getCampaignAlertsEndpoint(builder),
            getCampaignHealthStatus: getCampaignHealthStatusEndpoint(builder),
            getCampaignQuotaStats: getCampaignQuotaStatsEndpoint(builder),
            getCampaignCompletesStats: getCampaignCompletesStatsEndpoint(builder),
            getCampaignMatchesStats: getCampaignMatchesStatsEndpoint(builder),
            putResetCampaignPreflight: getPutResetCampaignPreflight(builder)
        };
    }
});
export var useGetCampaignQuery = tapi.useGetCampaignQuery, useGetCampaignsQuery = tapi.useGetCampaignsQuery, useGetCampaignAlertsQuery = tapi.useGetCampaignAlertsQuery, useGetCampaignQuotaStatsQuery = tapi.useGetCampaignQuotaStatsQuery, useGetCampaignCompletesStatsQuery = tapi.useGetCampaignCompletesStatsQuery, useGetCampaignMatchesStatsQuery = tapi.useGetCampaignMatchesStatsQuery, useGetCampaignHealthStatusQuery = tapi.useGetCampaignHealthStatusQuery, usePutResetCampaignPreflightMutation = tapi.usePutResetCampaignPreflightMutation;
